import { render, staticRenderFns } from "./ShangBiao.vue?vue&type=template&id=52c3730b&scoped=true"
import script from "./ShangBiao.vue?vue&type=script&lang=js"
export * from "./ShangBiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3730b",
  null
  
)

export default component.exports